import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ClubServicesService } from '../../services/club-services.service';

@Component({
  selector: 'app-player-details-dialogue',
  templateUrl: './player-details-dialogue.component.html',
  styleUrls: ['./player-details-dialogue.component.scss']
})
export class PlayerDetailsDialogueComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private csObj: CommonService,
    private toast: ToastrService,
    private router: Router,
    private dialogRef: MatDialog,
    private auth: AuthService,
    private  spinner: SpinnerVisibilityService,
    private clubService: ClubServicesService
  ) { }

  orderId:any;
  defaultImage = '../../../../assets/icons/Loading_icon.gif';
  playersList:any=[];

  ngOnInit(): void {
    this.playersList = this.data.userType.id;
    console.log(this.playersList,"playersList");
  }

  // Delete teams functionality
  DeletBtnClick() {
    try {
      this.csObj.deleteAPI(this.data.userType.id).subscribe((res: any) => {
        this.toast.success("Team Deleted successfully");
        let currentURL = this.router.url
        this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentURL]);
        });

      },
        (err: any) => {
          this.toast.error(err.message);
        })
    }
    catch (e) { }
  }


   // logout  functionality
   logoutClick() {
    this.orderId = localStorage.getItem('orderId');
    // alert(id);
    // this.csObj.cancelOrder$.subscribe((id:any)=>{
    //   alert('2'+id)
    // })
    this.clubService.cancelOrder(this.orderId).subscribe((res:any)=>{
      if(res.status == 200){
        this.router.navigate(['/manageOrders']);
        this.toast.success("order Canceled");
      }
    })
  }

}
